const DatabaseProduct = ({ product }) => {
  return (
    <tr className="even:bg-gray-100 flex flex-col xl:table-row">
      <td className="p-4 relative">
        <h3 className="block md:hidden xl:block md:mb-4">
          <a className="text-black text-xl mb-4 font-bold" href={product.permalink}>{product.title}</a>
        </h3>
        <div className="md:flex">
          <div className="flex items-center justify-center mb-4">
            <a href={product.permalink} className="flex items-center w-48 relative p-4 h-40">
              <img src={product.image} alt={product.title} />
              <span className="absolute bottom-2 right-2xl xl:bottom-2 xl:-right-2" dangerouslySetInnerHTML={{ __html: product.score }}></span>
            </a>
          </div>
          <div className="mb-2 md:px-4 md:ml-2 text-base">
            <h3 className="hidden md:block xl:hidden mb-4">
              <a href={product.permalink} className="text-black text-xl font-bold">{product.title}</a>
            </h3>
            {Object.entries(product.fields).map(([key, value], index) => (
                <div key={index} className="mb-1"><strong>{key}:</strong> {value}</div>
            ))}
            <a href={product.permalink} className="block mb-2 font-bold">See Full Specs &gt;&gt;</a>
          </div>
        </div>
      </td>
      <td className="md: p-4 pt-0">
        <div className="display-icon md:float-right text-center mb-4 md:mb-0 md:text-right text-lg">
          <div dangerouslySetInnerHTML={{ __html: product.price }}></div>
        </div>
      </td>
    </tr>
  );
};

export default DatabaseProduct;